var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { LayoutCentral } from '../../Components/LayoutCentral';
import { MedicationStatus } from '../../Contracts/MedicationModels';
import { DecisionSupportStep } from './DecisionSupport';
import { DecisionSupportLoading } from './DecisionSupportLoading';
import { PrescriptionMonitoringStep } from './PrescriptionMonitoringStep';
import { TimeoutSelector } from './TimeoutSelector';
var ChildStep;
(function (ChildStep) {
    ChildStep[ChildStep["PrescriptionMonitoring"] = 0] = "PrescriptionMonitoring";
})(ChildStep || (ChildStep = {}));
var NotedStep = function (props) {
    var _a, _b, _c;
    var _d = __read(useState(function () {
        var validChildSteps = [];
        if (props.state.response) {
            if (!props.state.response.prescriptionMonitoringNoted) {
                validChildSteps.push(ChildStep.PrescriptionMonitoring);
            }
        }
        return validChildSteps;
    }), 1), childSteps = _d[0];
    var _e = __read(useState(0), 2), childStep = _e[0], setChildStep = _e[1];
    var advanceChildStep = function () {
        if (childStep >= childSteps.length - 1)
            props.onContinue();
        else
            setChildStep(function (step) { return step++; });
    };
    var readOnlyView = !!props.patientMedication &&
        (((_a = props.patientMedication) === null || _a === void 0 ? void 0 : _a.status) !== MedicationStatus.Draft ||
            ((_c = (_b = props.patientMedication) === null || _b === void 0 ? void 0 : _b.decisionSupportDetail) === null || _c === void 0 ? void 0 : _c.decisionSupportNoted) === true);
    if (childStep === ChildStep.PrescriptionMonitoring) {
        return React.createElement(PrescriptionMonitoringStep, __assign({}, props, { readOnly: readOnlyView, onContinue: advanceChildStep }));
    }
    else {
        return React.createElement("div", null, "Step error");
    }
};
export var StepViewer = function (props) {
    var loadingPlaceholder = (React.createElement(LayoutCentral, null,
        React.createElement(DecisionSupportLoading, null)));
    if (props.state.step === DecisionSupportStep.Loading) {
        return loadingPlaceholder;
    }
    else if (props.state.step === DecisionSupportStep.Waiting) {
        // Same, but could be a different loading screen for waiting
        return loadingPlaceholder;
    }
    else if (props.state.step === DecisionSupportStep.Timeout) {
        return React.createElement(TimeoutSelector, { onSkip: props.onSkip, onWait: props.onWait });
    }
    else if (props.state.step === DecisionSupportStep.NotedStep) {
        return (React.createElement(NotedStep, { patient: props.patient, patientMedication: props.patientMedication, state: props.state, onContinue: props.onContinue, onNavigateToMedication: props.onNavigateToMedication }));
    }
    return null;
};
